export const GET_CMS_MENU = 'GET_CMS_MENU';
export const GET_CMS_MENU_SUCCESS = 'GET_CMS_MENU_SUCCESS';
export const GET_CMS_MENU_FAIL = 'GET_CMS_MENU_FAIL';
export const ADD_CMS_MENU = 'ADD_CMS_MENU';
export const EDIT_CMS_MENU = 'EDIT_CMS_MENU';
export const EDIT_CMS_SUB_MENU = 'EDIT_CMS_SUB_MENU';
export const ADD_CMS_SUB_MENU = 'ADD_CMS_SUB_MENU';
export const REMOVE_CMS_MENU = 'REMOVE_CMS_MENU';
export const REMOVE_CMS_SUB_MENU = 'REMOVE_CMS_SUB_MENU';
